/** Shared resident-home block chrome — keeps icon + text columns aligned across cards. */
export const RESIDENT_HOME_PREVIEW_LIMIT = 3;

/** Two-line preview rows (citations, permanent permits) — fetch 5; scroll inside the fixed list slot. */
export const RESIDENT_HOME_RECORD_PILLAR_PREVIEW_LIMIT = 5;

/** Pool & amenities — compact single-line rows; same preview count as record pillars. */
export const RESIDENT_HOME_AMENITIES_PREVIEW_LIMIT = 5;

export const RESIDENT_HOME_BLOCK_SHELL_CLASS = "rounded-xl border px-4 py-3";

/** Card shell: kills default Card `py-6` so top padding matches the welcome block. */
export const RESIDENT_HOME_CARD_SHELL_CLASS = "gap-0 overflow-hidden py-0 shadow-sm";

/** Pillar cards: header / fixed list slot / flex filler / pinned footer. */
export const RESIDENT_HOME_PILLAR_CARD_CONTENT_CLASS =
  "flex h-full min-h-0 flex-col gap-3";

/** Safelistings-style header row — content top-aligned; optional action on the right. */
export const RESIDENT_HOME_PILLAR_HEADER_ROW_CLASS = "flex shrink-0 items-start justify-between gap-3";

/** Invisible slot matching the safelistings **New** button (size `sm`, h-8). */
export const RESIDENT_HOME_PILLAR_HEADER_ACTION_SLOT_CLASS =
  "pointer-events-none h-8 w-[4.625rem] shrink-0 opacity-0 sm:w-[4.75rem]";

/** Fixed preview area — 3 tall rows + gaps; divider sits directly below this on every pillar. */
export const RESIDENT_HOME_PILLAR_LIST_SLOT_CLASS =
  "flex h-[14.5rem] min-h-0 shrink-0 flex-col";

/** Preview rows inside the fixed list slot. */
export const RESIDENT_HOME_PILLAR_LIST_CLASS = "flex min-h-0 flex-1 flex-col gap-2 overflow-hidden";

/** Same as list class but scrolls when preview count exceeds visible rows (citations, permits). */
export const RESIDENT_HOME_PILLAR_LIST_SCROLL_CLASS =
  "flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto";

/** Absorbs extra grid row height so footers share the same baseline. */
export const RESIDENT_HOME_PILLAR_FILLER_CLASS = "min-h-0 flex-1";

export const RESIDENT_HOME_PILLAR_FOOTER_CLASS = "border-border shrink-0 border-t pt-3";

/** Reserved height when a card has no footer row (empty / loading). */
export const RESIDENT_HOME_PILLAR_FOOTER_PLACEHOLDER_CLASS = "h-[2.75rem] shrink-0";

/** Overrides CardContent default `md:px-6` so blocks align with the welcome shell. */
export const RESIDENT_HOME_CARD_CONTENT_CLASS = "px-4 py-3 md:px-4";

/** Icon column width (size-9) + gap-3 text inset for nested rows (desktop only; mobile uses full width). */
export const RESIDENT_HOME_TEXT_INSET_CLASS = "sm:pl-12";

export const RESIDENT_HOME_ICON_ROW_CLASS = "flex min-w-0 gap-3";

export const RESIDENT_HOME_ICON_WRAPPER_CLASS =
  "flex size-9 shrink-0 items-center justify-center rounded-lg bg-primary/10";

export const RESIDENT_HOME_BLOCK_TITLE_CLASS = "text-foreground text-sm font-semibold";
